import { User } from '../Modules/User/Model/User';

export const SLOT_OPS_OVERRIDE_TOKEN_KEY = 'slotOpsOverrideToken';

type LimitedAdminCheckable = Pick<User, 'grade' | 'is_limited_partner_admin' | 'external_partner_flags'> | null | undefined;

export function isLimitedPartnerAdmin(user: LimitedAdminCheckable): boolean {
  if (!user) return false;
  if (user.is_limited_partner_admin) return true;
  if (user.grade === 'ADMIN' && user.external_partner_flags?.includes('limited-admin')) {
    return true;
  }
  return false;
}

/** 일반(비제한형) ADMIN */
export function isFullAdmin(user: User | null | undefined): boolean {
  return user?.grade === 'ADMIN' && !isLimitedPartnerAdmin(user);
}

export function canManageNotices(user: User | null | undefined): boolean {
  return isFullAdmin(user);
}

export function canDeleteLogs(user: User | null | undefined): boolean {
  return isFullAdmin(user);
}

export function canEditSlotDates(user: User | null | undefined): boolean {
  return user?.grade === 'ADMIN' && !isLimitedPartnerAdmin(user);
}

/** 슬롯 생성 시 시작일이 내일 이후여야 하는지 */
export function requiresTomorrowStartDate(user: User | null | undefined): boolean {
  if (!user) return true;
  if (user.grade !== 'ADMIN') return true;
  return isLimitedPartnerAdmin(user);
}

export function isSlotOpsOverrideActive(
  user: Pick<User, 'slot_ops_override'> | null | undefined,
): boolean {
  return !!user?.slot_ops_override?.active;
}

export function canUseSlotOpsOverride(user: User | null | undefined): boolean {
  const override = user?.slot_ops_override;
  return isLimitedPartnerAdmin(user) && !!override?.eligible && !!override?.configured;
}
